<template>
  <div>
    <account-confirmation></account-confirmation>
    <dashboard-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.ADMIN"></dashboard-admin>
    <dashboard-user v-if=" loggedUser && loggedUser.active && loggedUser.role === UserRoles.APPLICANT"></dashboard-user>
    <dashboard-auditor v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.AUDITOR"></dashboard-auditor>
    <dashboard-regional-admin v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.REGIONAL_ADMIN"></dashboard-regional-admin>
    <dashboard-evaluator v-if="loggedUser && loggedUser.active && loggedUser.role === UserRoles.EVALUATOR"></dashboard-evaluator>
  </div>
</template>
<script>
  import {UserRoles} from "@/services";
  import DashboardUser from './DashboardUser';
  import DashboardAdmin from './DashboardAdmin';
  import DashboardAuditor from './DashboardAuditor';
  import DashboardRegionalAdmin from './DashboardRegionalAdmin';
  import DashboardEvaluator from './DashboardEvaluator';
  import AccountConfirmation from "@/pages/Dashboard/AccountConfirmation";

  export default {
    data() {
      return {
        loggedUser: {},
        UserRoles
      }
    },
    components: {
      AccountConfirmation,
      DashboardUser,
      DashboardAdmin,
      DashboardAuditor,
      DashboardRegionalAdmin,
      DashboardEvaluator,
    },
    beforeMount() {
      this.loggedUser = this.$store.getters['Auth/loggedUser'];

      if (this.loggedUser.role === UserRoles.APPLICANT)
      {
          this.$router.push('/proposals');
      }
    }
  };
</script>
<style></style>
